/**
 * Trigger a browser download for a Blob using the
 * object-URL -> <a download> -> click -> revoke pattern.
 */
export const downloadFile = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

/**
 * Parse the filename out of a Content-Disposition header value, if present.
 * Handles both RFC 5987 (filename*=UTF-8'') and the quoted filename="..." form.
 */
export const getFilenameFromContentDisposition = (
  header?: string | null,
): string | null => {
  if (!header) {
    return null
  }

  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1])
    } catch {
      return utf8Match[1]
    }
  }

  const quotedMatch = header.match(/filename="?([^";]+)"?/i)
  return quotedMatch?.[1] ?? null
}
